import m from "../../../../geodata/es2015/region/usa/scHigh";
window.am4geodata_region_usa_scHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/scHigh.js
// module id = null
// module chunks = 